import React from "react";
import { useTranslation } from "react-i18next";

const BreakdownModal = ({ isOpen, onClose, title, children }) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 overflow-y-auto px-4 py-6 sm:px-0"
            style={{ zIndex: 99999 }}
        >
            <div
                className="fixed inset-0 transform transition-all"
                onClick={onClose}
            >
                <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-6xl sm:w-full mx-auto relative mt-10">
                <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between bg-gray-50">
                    <h3 className="text-lg font-semibold text-gray-900">
                        {title || t('breakdown')}
                    </h3>
                    <button
                        type="button"
                        className="text-gray-400 hover:text-gray-500 transition-colors"
                        onClick={onClose}
                    >
                        <span className="bi bi-x-lg text-xl"></span>
                    </button>
                </div>
                <div className="px-6 py-4 max-h-[80vh] overflow-y-auto">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default BreakdownModal;
